import TextInput from "../../UI/TextInput";
import TextArea from "../../UI/TextArea";
import Radio from "../../UI/Radio";

function ZoneTendue({ loyerReference }) {
  return (
    <>
      <p className={"marginT10"}>
        Soumis à l'encadrement des loyers fixé par arrêté prefectoral
      </p>
      <div className={"gridColWrap240 marginB10"}>
        <Radio name="loyer_reference" value="true" label="Oui" />
        <Radio name="loyer_reference" value="false" label="Non" />
      </div>

      {loyerReference && (
        <>
          <div className={"gridColWrap240"}>
            <TextInput
              type={"number"}
              name={"montant_loyer_ref"}
              label="Loyer de référence pour la zone"
              placeholder={"10"}
              unit={"€/m²"}
              step={"0.01"}
              mandatory
            />
            <TextInput
              type={"number"}
              name={"montant_loyer_ref_maj"}
              label="Loyer de référence majoré"
              placeholder={"11"}
              unit={"€/m²"}
              step={"0.01"}
              mandatory
            />
          </div>

          <TextInput
            type={"number"}
            name={"complement_loyer"}
            label="Si besoin, complément de loyer prévu"
            placeholder={"100"}
            unit={"€"}
            step={"0.01"}
          />
          <TextArea
            name={"justif_complement_loyer"}
            label="Justification du complément de loyer"
            placeholder={"Vue imprenable sur la ville"}
            rows={4}
          />
        </>
      )}
    </>
  );
}

export default ZoneTendue;
